import { useCallback, useEffect, useMemo } from 'react'
import useGetFilters from '../../../../hooks/useGetAllTags'
import Modal from 'components/Modal'
import { titleCase } from 'utils'
import { settings } from 'settings'

const FiltersPopup = ({
  filtersPopupOpened,
  closeModal,
  filteredCorrect,
  setFilteredTags,
  filteredTags,
  setFilteredCorrect,
  difficultyFilters,
  handleSelectDifficulty,
  hasSubscription,
  includeAdditionalCheckboxes = false,
  handleChangeChaptersByCourse,
  grileTypes,
  handleChangeGrileTypes,
}) => {
  const { coursesWithChapters, chapters } = useGetFilters()

  const handleCorrectCheckboxChange = useCallback(
    (event, value) => {
      let newFilteredCorrect
      if (filteredCorrect.includes(value)) {
        newFilteredCorrect = filteredCorrect.filter(item => item !== value)
      } else {
        newFilteredCorrect = [...filteredCorrect, value]
      }
      setFilteredCorrect(newFilteredCorrect)
    },
    [filteredCorrect, setFilteredCorrect],
  )

  const handleTagsCheckboxChange = useCallback(
    (event, tagId) => {
      // if (filteredTags.length === 1 && filteredTags.includes(tagId)) {
      //   return
      // }

      let newFilteredTags
      if (filteredTags.includes(tagId)) {
        newFilteredTags = filteredTags.filter(id => id !== tagId)
      } else {
        newFilteredTags = [...filteredTags, tagId]
      }
      setFilteredTags(newFilteredTags)
    },
    [filteredTags, setFilteredTags],
  )

  const mappedCheckboxes = useMemo(() => {
    const sortedCourses = Object.entries(coursesWithChapters || {}).sort(
      (a, b) => {
        const maxLengthA = Math.max(...a[1].map(chapter => chapter.name.length))
        const maxLengthB = Math.max(...b[1].map(chapter => chapter.name.length))
        return maxLengthB - maxLengthA
      },
    )

    return sortedCourses.map(([course, chapters]) => {
      // const disabled =
      //   !hasSubscription ||
      //   (chapters.every(chapter => filteredTags?.includes(chapter.id)) &&
      //     filteredTags?.length === chapters.length)

      const isSelected = chapters.every(chapter =>
        filteredTags?.includes(chapter.id),
      )

      return (
        <div key={course}>
          <label key={`label-${course}`} className="flex items-center gap-1">
            <input
              type="checkbox"
              id={`course-${course}`}
              name={`course-${course}`}
              checked={isSelected}
              className="!w-[20px] !h-[20px] cursor-pointer transition-all"
              onChange={() => handleChangeChaptersByCourse(course, isSelected)}
            />

            <div className="capitalize">{course}</div>
          </label>

          <div className="mt-[8px] mb-[9px] w-[55px] h-[0.2px] bg-gray-200"></div>

          {chapters.map((chapter, chapterIndex) => {
            const totalSelectedChapters = Object.values(
              coursesWithChapters || {},
            )
              .flat()
              .filter(chapter => filteredTags?.includes(chapter.id)).length

            const isOnlyOneSelected = totalSelectedChapters === 1

            // const isDisabled =
            //   !hasSubscription ||
            //   (isOnlyOneSelected && filteredTags?.includes(chapter.id))

            return (
              <label
                htmlFor={chapter?.id}
                key={`label-${chapterIndex}`}
                className="flex items-center gap-1 mt-[6px]"
              >
                <input
                  type="checkbox"
                  id={chapter?.id}
                  name={chapter?.id}
                  className="!w-4 !h-4 cursor-pointer"
                  checked={filteredTags?.includes(chapter?.id)}
                  onChange={event => {
                    handleTagsCheckboxChange(event, chapter?.id)
                  }}
                />

                <div className="capitalize text-[10px] lg:text-xs">
                  {chapter?.name}
                </div>
              </label>
            )
          })}
        </div>
      )
    })
  }, [
    coursesWithChapters,
    handleTagsCheckboxChange,
    filteredTags,
    handleChangeChaptersByCourse,
  ])

  const mappedDifficulty = useMemo(() => {
    const isOnlyOneSelected =
      difficultyFilters?.filter(item => item.checked).length === 1

    return difficultyFilters?.map((difficulty, index) => {
      // const isDisabled =
      //   (isOnlyOneSelected && difficulty.checked) || !hasSubscription

      return (
        <div key={`difficulty-${index}`} className="flex flex-col gap-2">
          <label
            htmlFor={difficulty?.key}
            key={difficulty?.key}
            className="flex items-center gap-1"
          >
            <input
              type="checkbox"
              id={difficulty?.key}
              name={difficulty?.key}
              className="!w-4 !h-4 cursor-pointer"
              checked={difficulty?.checked}
              onChange={() => handleSelectDifficulty(index)}
            />

            <div>{difficulty?.label}</div>
          </label>
        </div>
      )
    })
  }, [difficultyFilters, handleSelectDifficulty])

  const mappedGrileTypes = useMemo(() => {
    const isOnlyOneChecked =
      grileTypes?.filter(item => item.checked).length === 1

    return grileTypes?.map((type, index) => {
      // const isDisabled = (isOnlyOneChecked && type.checked) || !hasSubscription

      return (
        <label key={`grileType-${index}`} className="flex items-center gap-1">
          <input
            type="checkbox"
            className="!w-4 !h-4 cursor-pointer"
            defaultChecked={type.checked}
            onClick={() => handleChangeGrileTypes(index)}
          />
          <div>{type.name}</div>
        </label>
      )
    })
  }, [grileTypes, handleChangeGrileTypes])

  useEffect(() => {
    if (chapters?.length > 0) {
      const newFilteredTags = chapters?.map(tag => tag.id)
      setFilteredTags(newFilteredTags)
      setFilteredCorrect([0, 1])
    }
  }, [chapters, setFilteredCorrect, setFilteredTags])

  return (
    <Modal
      isOpen={filtersPopupOpened}
      closeModal={closeModal}
      title="Filtrează"
    >
      <div className="filter-istoric-grile text-over-ternary-background mt-3">
        {/* Solving Modes */}

        {/* Chapters */}
        <h1 className="opacity-40 text-lg mt-3">
          {titleCase(settings.materii)} / Capitole
        </h1>
        <div className={`mt-1 flex flex-row gap-10 w-full`}>
          {mappedCheckboxes}
        </div>

        {/* Difficulties */}
        <h1 className="opacity-40 text-lg mt-3">Dificultate</h1>
        <div className="flex gap-3 items-center mt-1">{mappedDifficulty}</div>
        <h1 className="opacity-40 text-lg mt-3">Tip</h1>

        {/* Type */}
        <div className="flex gap-3 items-center mt-1">{mappedGrileTypes}</div>
        {includeAdditionalCheckboxes ? (
          <div className="flex gap-3 items-center mt-1">
            <label htmlFor="correct" className="flex items-center gap-1 mt-3">
              <input
                // disabled={
                //   (filteredCorrect.length === 1 &&
                //     filteredCorrect.includes(1)) ||
                //   !hasSubscription
                // }
                type="checkbox"
                id="correct"
                name="correct"
                className="!w-4 !h-4 cursor-pointer"
                checked={filteredCorrect.includes(1)}
                onChange={event => handleCorrectCheckboxChange(event, 1)}
              />

              <div>Grile corecte</div>
            </label>
            <label htmlFor="incorrect" className="flex items-center gap-1 mt-3">
              <input
                // disabled={
                //   (filteredCorrect.length === 1 &&
                //     filteredCorrect.includes(0)) ||
                //   !hasSubscription
                // }
                type="checkbox"
                id="incorrect"
                name="incorrect"
                className="!w-4 !h-4 cursor-pointer"
                checked={filteredCorrect.includes(0)}
                onChange={event => handleCorrectCheckboxChange(event, 0)}
              />

              <div>Grile incorecte</div>
            </label>
          </div>
        ) : null}
      </div>{' '}
    </Modal>
  )
}

export default FiltersPopup
